import { ListItem } from '@mui/material';
import styled from 'styled-components';

const ImgLogo = styled.img`
  width: '200px';
  height: '80px';
`;
const NavBarContainer = styled.div`
  position: fixed;
  top: 0;
  height: '100px' !important;
  width: ${({ isMobile }) => (isMobile ? `100%` : `calc(100% - 10rem)`)} !important;
  background-color: white;
  display: flex;
  z-index: 10;
  justify-content: ${({ isMobile }) => (isMobile ? `space-between` : `space-around`)};
  // flex-wrap: wrap;
  align-content: center;
  padding: ${({ isMobile }) => (isMobile ? 0 : `0 5rem`)};
`;

const ButtonNavBar = styled.button`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #0997ba;
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  &:hover {
    color: #ee7b57;
  }
`;

const StyledListItem = styled(ListItem)`
  border-radius: 20px;
  ${({ accent }) => !!accent && `background-color: rgb(238 123 87 / 0.2);`}
`;

export { ImgLogo, NavBarContainer, ButtonNavBar, StyledListItem };
